const camposTurnosWeb = [
  "mutualOtorgaWeb",
  "MutualOtorgaWeb",
  "otorgaWeb",
  "OtorgaWeb",
];

export const mutualPermiteTurnosWeb = (paciente = {}) => {
  const campo = camposTurnosWeb.find(
    (nombre) => paciente[nombre] !== undefined && paciente[nombre] !== null
  );

  // Las sesiones creadas antes de incorporar el campo quedan protegidas por el
  // backend. No se las bloquea preventivamente por no tener información.
  if (!campo) return true;

  const valor = paciente[campo];
  if (typeof valor === "boolean") return valor;
  if (typeof valor === "number") return valor !== 0;
  if (typeof valor === "string") {
    return !["false", "0", "no"].includes(valor.trim().toLowerCase());
  }

  return true;
};

export const mensajeMutualSinTurnosWeb =
  "Tu mutual no está habilitada para reservar turnos vía web. Comunicate con la institución para coordinar tu atención.";

export const nombreVisibleMutual = (nombre) => {
  if (typeof nombre !== "string") return "";

  // Gasalud agrega a algunas mutuales un detalle técnico de prácticas entre
  // paréntesis. Es información de configuración, no parte del nombre visible.
  return nombre
    .replace(
      /\s*\((?=[^)]*\b(?:TAC|RMN|RX|MAMO|ECO|ECODOPPLER|ORTOPAN)\b)[^)]*\)\s*$/i,
      ""
    )
    .trim();
};
